import { ChangeDetectionStrategy, Component, ElementRef, Input } from '@angular/core';
import { DomainCategoryEnum } from '@models/search/domain-category.enum';

@Component({
  selector: 'app-i18n-domain-category',
  templateUrl: './i18n-domain-category.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class I18nDomainCategoryComponent {
  DomainCategoryEnum = DomainCategoryEnum;

  @Input() model: DomainCategoryEnum;

  get value(): string {
    return this.el.nativeElement.textContent;
  }

  constructor(private readonly el: ElementRef) {}
}
